// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1vOYW","alertIcon":"ConfirmModal_alertIcon__Gvt4Q"};